import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";
import AppBar from "./components/AppBar";
import Footer from "./components/Footer";
import Work from "./pages/Work";
import About from "./pages/About";
import ProjectDetails from "./pages/ProjectDetails";

import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import RequireAdmin from "./admin/RequireAdmin";
import Customers from "./admin/pages/Customers";
import Invoices from "./admin/pages/Invoices";

import PortfolioPage from "./pages/PortfolioPage";

import "./App.css";

function AppWrapper() {
  const location = useLocation();
  const path = location.pathname.toLowerCase();

  const hideNavbar = path.startsWith("/project/");
  const isAdminRoute = path.startsWith("/admin");

  const hostname = window.location.hostname.toLowerCase();
  const parts = hostname.split(".").filter(Boolean);
  const sub = parts[0] || "";

  // ✅ treat *.localhost as subdomain for dev
  const isLocalhostFamily = hostname === "localhost" || hostname.endsWith(".localhost");

  // ✅ production: sub.domain.com (>=3 parts), dev: abid.localhost (2 parts + endsWith .localhost)
  const isLikelySubdomain =
    (parts.length > 2 && sub !== "www") ||
    (isLocalhostFamily && parts.length === 2 && sub !== "www" && sub !== "localhost");


  // ✅ penting: buat early-return sebelum JSX utama
  if (isLikelySubdomain && !isAdminRoute) {
    return <PortfolioPage />;
  }

  return (
    <div className="app-container">
      {!hideNavbar && !isAdminRoute && <AppBar />}

      <div className="main-content">
        <Routes>
          <Route path="/" element={<Work />} />
          <Route path="/about" element={<About />} />
          <Route path="/project/:id" element={<ProjectDetails />} />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <RequireAdmin>
                <AdminLayout />
              </RequireAdmin>
            }
          >
            <Route index element={<Navigate to="/admin/customers" replace />} />
            <Route path="customers" element={<Customers />} />
            <Route path="invoices" element={<Invoices />} />
          </Route>

          <Route path="*" element={<div style={{ padding: 24 }}>Not Found</div>} />
        </Routes>
      </div>

      {!isAdminRoute && <Footer />}
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}
